import { render, staticRenderFns } from "./TransfusionNote.vue?vue&type=template&id=61ec4342&scoped=true"
import script from "./TransfusionNote.vue?vue&type=script&lang=js"
export * from "./TransfusionNote.vue?vue&type=script&lang=js"
import style0 from "./TransfusionNote.vue?vue&type=style&index=0&id=61ec4342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec4342",
  null
  
)

export default component.exports